import { combineReducers } from 'redux';
import { boundaryToolStateReducer } from './boundary/boundaryToolState.state';
import { dataLayersToolReducer } from './dataLayers/dataLayers.reducers';
import { directionsReducer } from './directions/directions.reducer';
import { distanceCalculatorReducer } from './distanceCalculator/distanceCalculator.reducer';
import { mapToolsDrawingReducer } from './drawing/mapToolsDrawing.reducer';
import { heatmapFormReducer } from './heatmap/heatmapForm.reducer';
import { lassoReducer } from './lasso/lasso.reducer';
import { locationFinderReducer } from './locationFinder/locationFinder.reducer';
import { markersSelectReducer } from './markersSelect/markersSelect.reducer';
import { myLocationReducer } from './myLocation/myLocation.reducer';
import { searchReducer } from './search/search.reducer';
import { selectLocationReducer } from './selectLocation/selectLocation.reducer';
import { shapeDrawReducer } from './shapeDraw/shapeDraw.reducer';
import { streetViewReducer } from './streetView/streetView.reducer';
import { weightedCenterReducer } from './weightedCenter/weightedCenter.reducer';

export const mapToolsReducer = combineReducers({
  selectionLocation: selectLocationReducer,
  boundary: boundaryToolStateReducer,
  directions: directionsReducer,
  distanceCalculator: distanceCalculatorReducer,
  drawing: mapToolsDrawingReducer,
  heatmap: heatmapFormReducer,
  lasso: lassoReducer,
  locationFinder: locationFinderReducer,
  markersSelect: markersSelectReducer,
  myLocation: myLocationReducer,
  search: searchReducer,
  shapeDraw: shapeDrawReducer,
  streetView: streetViewReducer,
  dataLayers: dataLayersToolReducer,
  weightedCenter: weightedCenterReducer,
});
